module.exports = __webpack_public_path__ + "media/images/no-project-e405ead394ce197a0a2e4b7b7a8d6a51.png";